import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../reducers/userInfoReducer';
import { selectDefaultCreationEnvironment } from './environmentsReducer';
import { useChangeEnvironment } from '../../../hooks/useChangeEnvironment';
import type { CrmOrg } from '../../../types/CrmOrgs';

interface DefaultEnvContextType {
  crmOrgId: string | undefined;
  crmOrg: CrmOrg | undefined;
  changeEnvironment: (targetCrmOrgId: string | null) => void;
}

const DefaultEnvContext = React.createContext<DefaultEnvContextType | undefined>(undefined);

export const GlobalDefaultEnvProvider = ({ children }: { children: React.ReactNode }) => {
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId) ?? undefined;
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { changeEnvironment } = useChangeEnvironment();

  return (
    <DefaultEnvContext.Provider value={{ crmOrgId, crmOrg, changeEnvironment }}>
      {children}
    </DefaultEnvContext.Provider>
  );
};

const useDefaultEnvContext = () => {
  const ctx = useContext(DefaultEnvContext);
  if (!ctx) {
    throw new Error('useDefaultEnvContext must be used within a GlobalDefaultEnvProvider');
  }
  return ctx;
};

export const useDefaultEnvId = () => useDefaultEnvContext().crmOrgId;

export const useDefaultEnv = () => useDefaultEnvContext().crmOrg;

export const useChangeDefaultEnv = () => useDefaultEnvContext().changeEnvironment;
